export default defineNuxtPlugin( ( nuxtApp ) => {
  const { showComponent } = useComponentVisibility( "trial-dialog" )

  const openTrialModal = () => {
    showComponent()
  }

  nuxtApp.provide( "openTrialModal", openTrialModal )
} )
